import { IonAccordionGroup, IonButton, IonCol, IonRow } from "@ionic/react";
import { useHistory } from "react-router";
import BasicPage from "../baseComponents/basicPage/BasicPage";
import "./Account.css";
import DeleteAccount from "./DeleteAccount/DeleteAccount";
import StatsPoleTechnoAccordion from "./Stats/StatsPoleTechnoAccordion";
import StatsPoleTutoAccordion from "./Stats/StatsPoleTutoAccordion";
import Time from "./Time/Time";
import UpdateUser from "./UpdateUser/UpdateUser";

interface Prop {
  pathLogo: string;
}

export interface poleDisplay {
  name: string;
  number: number;
  active?: boolean;
}

const Account: React.FC<Prop> = ({ pathLogo }) => {
  const history = useHistory();

  return (
    <BasicPage
      pathLogo={pathLogo}
      subtitle="Voici les informations sur votre compte"
      title="Bienvenue"
      pathReturn="welcome"
    >
      <IonRow>
        <IonCol>
          {/* time */}
          <Time />

          <IonAccordionGroup>
            {/* stats techno */}
            <StatsPoleTechnoAccordion />

            {/* stats pratique */}
            <StatsPoleTutoAccordion />

            {/* update user */}
            <UpdateUser />
          </IonAccordionGroup>
        </IonCol>
      </IonRow>
      <IonRow className="ion-justify-content-center">
        <IonCol
          size="12"
          sizeSm="12"
          sizeLg="6"
          className="ion-justify-content-center"
        >
          <IonButton
            expand="full"
            color="secondary"
            shape="round"
            strong
            onClick={() => {
              localStorage.clear();
              window.location.reload();
            }}
          >
            Se déconnecter
          </IonButton>
        </IonCol>
      </IonRow>
      <DeleteAccount />
    </BasicPage>
  );
};

export default Account;
